import { useLang } from "../contexts/LanguageContext";
import { GLOSSARY } from "../lib/finance";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { BookOpen } from "lucide-react";

export default function Glossary() {
  const { t, lang } = useLang();
  const items = GLOSSARY[lang] || GLOSSARY.fr;

  return (
    <div className="mx-auto max-w-3xl px-6 py-16" data-testid="glossary-page">
      <div className="mb-8 flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#101A42]/10 text-[#101A42]">
          <BookOpen className="h-6 w-6" />
        </div>
        <div>
          <h1 className="font-serif text-4xl font-semibold text-[#101A42] sm:text-5xl">
            {t("glossary")}
          </h1>
          <p className="mt-1 text-lg text-[#4A4A4A]">{t("glossary_intro")}</p>
        </div>
      </div>

      <Accordion type="single" collapsible className="rounded-2xl border border-[#E8DFC7] bg-white">
        {items.map((it, i) => (
          <AccordionItem
            key={it.term}
            value={`item-${i}`}
            data-testid={`glossary-item-${i}`}
            className="border-b border-[#E8DFC7] last:border-b-0"
          >
            <AccordionTrigger className="px-6 py-5 text-left text-xl font-semibold text-[#101A42] hover:no-underline">
              {it.term}
            </AccordionTrigger>
            <AccordionContent className="px-6 pb-5 text-lg leading-relaxed text-[#333333]">
              {it.def}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
